import { useLocale as useUntypedLocale } from 'next-intl';
import { createNavigation } from 'next-intl/navigation';

import { i18n, pathnames } from './config';

// https://github.com/amannn/next-intl/discussions/477
export function useLocale() {
  return useUntypedLocale() as (typeof i18n.locales)[number];
}

const { Link, redirect, usePathname, useRouter } = createNavigation({
  locales: i18n.locales,
  localePrefix: 'as-needed',
  defaultLocale: i18n.defaultLocale,
  // The `string & {}` trick widens to a non-literal string while keeping
  // autocomplete on the union members. typescript-eslint v8 renamed the
  // old `ban-types` rule into smaller ones (`no-empty-object-type` covers
  // this case); both are turned off in eslint.config.mjs so we don't need
  // a disable comment anymore.
  pathnames: pathnames as typeof pathnames & Record<string & {}, string>,
});

export { Link, redirect, usePathname, useRouter };
